import { API, graphqlOperation } from "aws-amplify";

import { listJobRolesForSelectQuery } from "./graphql/queries";

const listJobRolesForSelect = () =>
  API.graphql(graphqlOperation(listJobRolesForSelectQuery));

export default listJobRolesForSelect;
